'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var auth = require('@tarslib/types/lib/auth');
var securityScheme = require('@tarslib/types/lib/securityScheme');
var lodash = require('lodash');
var SecurityScheme = require('./SecurityScheme.js');
var utils_isAuthInherit = require('./utils/isAuthInherit.js');
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), Object.defineProperty(e, "prototype", {
    writable: false
  }), e;
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: true,
    configurable: true,
    writable: true
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r);
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function getUsedSecuritySchemes(securitySchemeMap, securitySchemeUseCase) {
  var _securitySchemeUseCas, _securitySchemeUseCas2;
  var schemeGroups = securitySchemeUseCase === null || securitySchemeUseCase === void 0 ? void 0 : securitySchemeUseCase.schemeGroups;
  if (!Array.isArray(schemeGroups)) {
    schemeGroups = [];
  }
  var useSchemeId = (securitySchemeUseCase === null || securitySchemeUseCase === void 0 || (_securitySchemeUseCas = securitySchemeUseCase.useOverride) === null || _securitySchemeUseCas === void 0 ? void 0 : _securitySchemeUseCas.id) || (securitySchemeUseCase === null || securitySchemeUseCase === void 0 || (_securitySchemeUseCas2 = securitySchemeUseCase.use) === null || _securitySchemeUseCas2 === void 0 ? void 0 : _securitySchemeUseCas2.id);
  var schemeGroup = schemeGroups.find(function (group) {
    return group.id === useSchemeId;
  });
  if (!schemeGroup) {
    return null;
  }
  var schemeIds = schemeGroup.schemeIds;
  if (!Array.isArray(schemeIds)) {
    schemeIds = [];
  }
  return schemeIds.reduce(function (result, schemeId) {
    var scheme = securitySchemeMap[schemeId];
    if (!scheme) return result;
    if (scheme.authType !== securityScheme.SecuritySchemeAuthType.COMBINATION) {
      result.push(lodash.cloneDeep(scheme));
    }
    var group = scheme.authConfigs.group;
    if (!Array.isArray(group)) {
      group = [];
    }
    group.forEach(function (item) {
      var s = securitySchemeMap[item.id];
      if (s) {
        result.push(lodash.cloneDeep(s));
      }
    });
    return result;
  }, []);
}
function getUsedSecurityScheme(securitySchemeMap, securitySchemeUseCase) {
  var _securitySchemeUseCas3, _securitySchemeUseCas4;
  var schemeGroups = securitySchemeUseCase === null || securitySchemeUseCase === void 0 ? void 0 : securitySchemeUseCase.schemeGroups;
  if (!Array.isArray(schemeGroups)) {
    schemeGroups = [];
  }
  var useSchemeId = (securitySchemeUseCase === null || securitySchemeUseCase === void 0 || (_securitySchemeUseCas3 = securitySchemeUseCase.useOverride) === null || _securitySchemeUseCas3 === void 0 ? void 0 : _securitySchemeUseCas3.id) || (securitySchemeUseCase === null || securitySchemeUseCase === void 0 || (_securitySchemeUseCas4 = securitySchemeUseCase.use) === null || _securitySchemeUseCas4 === void 0 ? void 0 : _securitySchemeUseCas4.id);
  var schemeGroup = schemeGroups.find(function (group) {
    return group.id === useSchemeId;
  });
  if (!schemeGroup) {
    return null;
  }
  var schemeId = schemeGroup.schemeIds[0];
  if (!schemeId) {
    return null;
  }
  return lodash.cloneDeep(securitySchemeMap[schemeId] || null);
}
var DEFINITION_INHERIT_FROM_ROOT = {
  name: '',
  id: 0
};
function getInheritAuthInfo() {
  var _currentFolder$auth;
  var folderId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var folderMap = arguments.length > 1 ? arguments[1] : undefined;
  var commonAuth = arguments.length > 2 ? arguments[2] : undefined;
  var commonSecurityScheme = arguments.length > 3 ? arguments[3] : undefined;
  // root folder
  if (!folderId) {
    return {
      definitionInheritFrom: _objectSpread({}, DEFINITION_INHERIT_FROM_ROOT),
      valueInheritFrom: {
        name: '',
        id: 0
      },
      auth: commonAuth || {
        type: auth.AuthValue.NoAuth
      },
      securityScheme: commonSecurityScheme
    };
  }
  var currentFolder = folderMap[folderId];
  if (!currentFolder) return undefined;
  var auth$1 = (_currentFolder$auth = currentFolder.auth) !== null && _currentFolder$auth !== void 0 ? _currentFolder$auth : {};
  if (utils_isAuthInherit.isAuthInherit(auth$1)) {
    var _currentFolder$securi, _currentFolder$auth2, _currentFolder$auth3, _currentFolder$securi2, _result$securitySchem, _result$securitySchem2, _result$securitySchem3, _currentFolder$securi3;
    var result = getInheritAuthInfo(currentFolder.parentId, folderMap, commonAuth, commonSecurityScheme);
    if (result && result.auth && typeof result.auth.type === 'string') {
      var overrideAuthValue = lodash.get(auth$1, [auth.AuthValue.InHerit, result.auth.type]);
      if (overrideAuthValue) {
        result.auth = _objectSpread(_objectSpread({}, result.auth), {}, _defineProperty({}, result.auth.type, _objectSpread(_objectSpread({}, result.auth[result.auth.type]), overrideAuthValue)));
      }
    }
    return _objectSpread(_objectSpread({}, result), {}, {
      definitionInheritFrom: (result === null || result === void 0 ? void 0 : result.definitionInheritFrom) || _objectSpread({}, DEFINITION_INHERIT_FROM_ROOT),
      auth: (result === null || result === void 0 ? void 0 : result.auth) || {},
      valueInheritFrom: (_currentFolder$securi = currentFolder.securityScheme) !== null && _currentFolder$securi !== void 0 && _currentFolder$securi.useOverride || ((_currentFolder$auth2 = currentFolder.auth) === null || _currentFolder$auth2 === void 0 ? void 0 : _currentFolder$auth2.type) === auth.AuthValue.InHerit && (_currentFolder$auth3 = currentFolder.auth) !== null && _currentFolder$auth3 !== void 0 && _currentFolder$auth3[auth.AuthValue.InHerit] ? {
        name: currentFolder.name,
        id: currentFolder.id
      } : result === null || result === void 0 ? void 0 : result.valueInheritFrom,
      securityScheme: _objectSpread(_objectSpread({}, result === null || result === void 0 ? void 0 : result.securityScheme), {}, {
        use: ((_currentFolder$securi2 = currentFolder.securityScheme) === null || _currentFolder$securi2 === void 0 ? void 0 : _currentFolder$securi2.useOverride) || (result === null || result === void 0 || (_result$securitySchem = result.securityScheme) === null || _result$securitySchem === void 0 ? void 0 : _result$securitySchem.useOverride) || (result === null || result === void 0 || (_result$securitySchem2 = result.securityScheme) === null || _result$securitySchem2 === void 0 ? void 0 : _result$securitySchem2.use),
        scopes: _objectSpread(_objectSpread({}, result === null || result === void 0 || (_result$securitySchem3 = result.securityScheme) === null || _result$securitySchem3 === void 0 ? void 0 : _result$securitySchem3.scopes), (_currentFolder$securi3 = currentFolder.securityScheme) === null || _currentFolder$securi3 === void 0 ? void 0 : _currentFolder$securi3.scopes)
      })
    });
  }
  return {
    definitionInheritFrom: {
      name: currentFolder.name,
      id: currentFolder.id
    },
    auth: auth$1.type && auth$1.type === auth.AuthValue.NoAuth ? {
      type: auth.AuthValue.NoAuth
    } : auth$1,
    securityScheme: currentFolder.securityScheme
  };
}
function mergeSecurityScheme(apiDetailSecurityScheme, apiCaseSecurityScheme, options) {
  var apiCaseSchemeGroups = apiCaseSecurityScheme === null || apiCaseSecurityScheme === void 0 ? void 0 : apiCaseSecurityScheme.schemeGroups;
  var apiDetailSchemeGroups = apiDetailSecurityScheme === null || apiDetailSecurityScheme === void 0 ? void 0 : apiDetailSecurityScheme.schemeGroups;
  var schemeGroups = [];
  if (options !== null && options !== void 0 && options.useHttpApiParameters) {
    schemeGroups = Array.isArray(apiDetailSchemeGroups) ? apiDetailSchemeGroups : Array.isArray(apiCaseSchemeGroups) ? apiCaseSchemeGroups : [];
  } else {
    schemeGroups = Array.isArray(apiCaseSchemeGroups) ? apiCaseSchemeGroups : Array.isArray(apiDetailSchemeGroups) ? apiDetailSchemeGroups : [];
  }
  var result = _objectSpread(_objectSpread({}, apiCaseSecurityScheme), {}, {
    schemeGroups: schemeGroups,
    required: options !== null && options !== void 0 && options.useHttpApiParameters ? (apiDetailSecurityScheme === null || apiDetailSecurityScheme === void 0 ? void 0 : apiDetailSecurityScheme.required) || (apiCaseSecurityScheme === null || apiCaseSecurityScheme === void 0 ? void 0 : apiCaseSecurityScheme.required) || false : (apiCaseSecurityScheme === null || apiCaseSecurityScheme === void 0 ? void 0 : apiCaseSecurityScheme.required) || (apiDetailSecurityScheme === null || apiDetailSecurityScheme === void 0 ? void 0 : apiDetailSecurityScheme.required) || false
  });
  if (options !== null && options !== void 0 && options.useUseFieldOfApiDetailAsFallback) {
    result.use = (apiCaseSecurityScheme === null || apiCaseSecurityScheme === void 0 ? void 0 : apiCaseSecurityScheme.use) || (apiDetailSecurityScheme === null || apiDetailSecurityScheme === void 0 ? void 0 : apiDetailSecurityScheme.use);
  }
  return result;
}
function translateSecuritySchemeToAuth(scheme, useCase) {
  var oAuth2GrantTypeNamePathInUseCase = SecurityScheme.getOAuth2GrantTypeNamePathInUseCase(scheme.id);
  var accessTokenFormItemNameInUseCase = SecurityScheme.getAuthConfigsAccessTokenFormItemNameInUseCase(scheme.id);
  var authType = scheme.authType,
    authConfigs = scheme.authConfigs;
  switch (authType) {
    case securityScheme.SecuritySchemeAuthType.OAUTH2:
      var useGrantType = lodash.get({
        securityScheme: useCase
      }, oAuth2GrantTypeNamePathInUseCase);
      var accessToken = lodash.get({
        securityScheme: useCase
      }, accessTokenFormItemNameInUseCase);
      var oAuth2 = SecurityScheme.getOAuth2(useGrantType, {
        authConfigs: authConfigs
      });
      oAuth2.accessToken = accessToken;
      return {
        type: auth.AuthValue.OAuth2,
        oauth2: oAuth2
      };
    case securityScheme.SecuritySchemeAuthType.APIKEY:
      var apiKey = SecurityScheme.getApiKey({
        authConfigs: authConfigs
      });
      return {
        type: auth.AuthValue.APIKey,
        apikey: apiKey
      };
    case securityScheme.SecuritySchemeAuthType.BEARER:
      var bearer = SecurityScheme.getBearerToken({
        authConfigs: authConfigs
      });
      return {
        type: auth.AuthValue.BearerToken,
        bearer: bearer
      };
    case securityScheme.SecuritySchemeAuthType.JWT:
      var jwt = SecurityScheme.getJwt({
        authConfigs: authConfigs
      });
      return {
        type: auth.AuthValue.JWT,
        jwt: jwt
      };
    case securityScheme.SecuritySchemeAuthType.BASIC:
      var basic = SecurityScheme.getBasic({
        authConfigs: authConfigs
      });
      return {
        type: auth.AuthValue.BasicAuth,
        basic: basic
      };
    case securityScheme.SecuritySchemeAuthType.DIGEST:
      var digest = SecurityScheme.getDigest({
        authConfigs: authConfigs
      });
      return {
        type: auth.AuthValue.DigestAuth,
        digest: digest
      };
    case securityScheme.SecuritySchemeAuthType.OAUTH1:
      var oauth1 = SecurityScheme.getOAuth1({
        authConfigs: authConfigs
      });
      return {
        type: auth.AuthValue.OAuth1,
        oauth1: oauth1
      };
    case securityScheme.SecuritySchemeAuthType.HAWK:
      var hawk = SecurityScheme.getHawk({
        authConfigs: authConfigs
      });
      return {
        type: auth.AuthValue.Hawk,
        hawk: hawk
      };
    case securityScheme.SecuritySchemeAuthType.AWSV4:
      var awsv4 = SecurityScheme.getAws({
        authConfigs: authConfigs
      });
      return {
        type: auth.AuthValue.AWS,
        awsv4: awsv4
      };
    case securityScheme.SecuritySchemeAuthType.KERBEROS1:
      var kerberos1 = SecurityScheme.getKerberos({
        authConfigs: authConfigs
      });
      return {
        type: auth.AuthValue.Kerberos,
        kerberos1: kerberos1
      };
    case securityScheme.SecuritySchemeAuthType.NTLM:
      var ntlm = SecurityScheme.getNtlm({
        authConfigs: authConfigs
      });
      return {
        type: auth.AuthValue.NTLM,
        ntlm: ntlm
      };
    case securityScheme.SecuritySchemeAuthType.EDGEGRID:
      var edgegrid = SecurityScheme.getEdgeGrid({
        authConfigs: authConfigs
      });
      return {
        type: auth.AuthValue.EdgeGrid,
        edgegrid: edgegrid
      };
    default:
      return null;
  }
}
function getAuthFromAuthAndSecuritySchemeUseCase(auth$1, useCase, securitySchemeMap) {
  if (!auth$1 || ![auth.AuthValue.SecurityScheme, auth.LegacySecuritySchemeAuthType].includes(auth$1.type || '')) {
    return auth$1;
  }
  var schemes = getUsedSecuritySchemes(securitySchemeMap || {}, useCase);
  if (!(schemes !== null && schemes !== void 0 && schemes.length)) {
    return {
      type: auth.AuthValue.NoAuth
    };
  }
  var authList = schemes.map(function (scheme) {
    var authConfigsInUse = lodash.get(_defineProperty({}, SecurityScheme.securitySchemeName, useCase), SecurityScheme.getAuthConfigsNamePathInUseCase(scheme.id));
    var authConfigsInUseOverride = lodash.get(_defineProperty({}, SecurityScheme.securitySchemeName, useCase), SecurityScheme.getConfigsForSechemeBaseNamePathInUseOverride(scheme.id));
    var authConfigs = lodash.merge(scheme.authConfigs, authConfigsInUseOverride || authConfigsInUse);
    return translateSecuritySchemeToAuth(_objectSpread(_objectSpread({}, scheme), {}, {
      authConfigs: authConfigs
    }), useCase) || auth$1;
  });
  if (authList.length === 1) {
    return authList[0];
  }
  return {
    type: auth.AuthValue.Combination,
    combination: authList
  };
}
var AuthBuilder = /*#__PURE__*/function () {
  function AuthBuilder(_ref) {
    var httpApi = _ref.httpApi,
      httpApiCase = _ref.httpApiCase,
      commonAuth = _ref.commonAuth,
      commonSecurityScheme = _ref.commonSecurityScheme,
      folderId = _ref.folderId,
      httpFolderMap = _ref.httpFolderMap,
      _ref$useHttpApiParame = _ref.useHttpApiParameters,
      useHttpApiParameters = _ref$useHttpApiParame === void 0 ? true : _ref$useHttpApiParame,
      securitySchemeMap = _ref.securitySchemeMap;
    _classCallCheck(this, AuthBuilder);
    _defineProperty(this, "DEFAULT_AUTH_VALUE", {});
    _defineProperty(this, "NO_AUTH", {
      type: auth.AuthValue.NoAuth
    });
    this.httpApiAuth = httpApi.auth || {};
    this.httpApiCaseAuth = httpApiCase === null || httpApiCase === void 0 ? void 0 : httpApiCase.auth;
    this.commonAuth = commonAuth;
    this.commonSecurityScheme = commonSecurityScheme;
    this.securitySchemeMap = securitySchemeMap;
    this.folderId = folderId;
    this.httpFolderMap = httpFolderMap !== null && httpFolderMap !== void 0 ? httpFolderMap : {};
    this.auth = useHttpApiParameters ? this.mergeAuth() : this.httpApiCaseAuth || {};
    this.securityScheme = mergeSecurityScheme(httpApi.securityScheme, httpApiCase === null || httpApiCase === void 0 ? void 0 : httpApiCase.securityScheme, {
      useUseFieldOfApiDetailAsFallback: true,
      useHttpApiParameters: useHttpApiParameters
    });
  }

  // httpApiCase 可以覆盖 httpApi 中的 auth
  return _createClass(AuthBuilder, [{
    key: "mergeAuth",
    value: function mergeAuth() {
      var _this$httpApiCaseAuth, _this$httpApiAuth;
      var apiCaseAuthType = (_this$httpApiCaseAuth = this.httpApiCaseAuth) === null || _this$httpApiCaseAuth === void 0 ? void 0 : _this$httpApiCaseAuth.type;
      var apiAuthType = ((_this$httpApiAuth = this.httpApiAuth) === null || _this$httpApiAuth === void 0 ? void 0 : _this$httpApiAuth.type) || auth.AuthValue.InHerit;
      if (!apiCaseAuthType) {
        return this.httpApiAuth;
      }
      if (apiAuthType === auth.AuthValue.InHerit) {
        if (apiAuthType === apiCaseAuthType) {
          return this.httpApiCaseAuth || {};
        }
        return this.httpApiAuth;
      }
      if (apiAuthType !== apiCaseAuthType) {
        return this.httpApiAuth;
      }
      return this.httpApiCaseAuth || this.httpApiAuth || {};
    }
  }, {
    key: "getAuthDataToBuild",
    value: function getAuthDataToBuild(httpApiAuth, securityScheme) {
      var _inheritAuthInfo$secu;
      // 非继承
      if (!utils_isAuthInherit.isAuthInherit(httpApiAuth)) {
        return getAuthFromAuthAndSecuritySchemeUseCase(httpApiAuth, _objectSpread({}, securityScheme), this.securitySchemeMap || {});
      }
      // 继承（子目录）
      var inheritAuthInfo = getInheritAuthInfo(this.folderId, this.httpFolderMap, this.commonAuth, this.commonSecurityScheme);
      var folderAuth = getAuthFromAuthAndSecuritySchemeUseCase(inheritAuthInfo === null || inheritAuthInfo === void 0 ? void 0 : inheritAuthInfo.auth, _objectSpread(_objectSpread({}, inheritAuthInfo === null || inheritAuthInfo === void 0 ? void 0 : inheritAuthInfo.securityScheme), {}, {
        use: this.securityScheme.useOverride || (inheritAuthInfo === null || inheritAuthInfo === void 0 || (_inheritAuthInfo$secu = inheritAuthInfo.securityScheme) === null || _inheritAuthInfo$secu === void 0 ? void 0 : _inheritAuthInfo$secu.use)
      }), this.securitySchemeMap || {});
      if (!utils_isAuthInherit.isAuthInherit(folderAuth)) {
        return folderAuth;
      }

      // 继承（根目录）
      var commonAuth = this.commonAuth,
        commonSecurityScheme = this.commonSecurityScheme;
      if (!utils_isAuthInherit.isAuthInherit(commonAuth)) {
        return getAuthFromAuthAndSecuritySchemeUseCase(commonAuth, _objectSpread(_objectSpread({}, commonSecurityScheme), {}, {
          use: this.securityScheme.useOverride || (commonSecurityScheme === null || commonSecurityScheme === void 0 ? void 0 : commonSecurityScheme.use)
        }), this.securitySchemeMap || {});
      }
      return undefined;
    }
  }, {
    key: "resolveAuth",
    value: function resolveAuth() {
      var _authData;
      var NO_AUTH = this.NO_AUTH,
        DEFAULT_AUTH_VALUE = this.DEFAULT_AUTH_VALUE;
      var auth$1 = this.auth,
        securityScheme = this.securityScheme;
      if (auth$1 && auth$1.type === auth.AuthValue.NoAuth) {
        return NO_AUTH;
      }
      var isInherit = utils_isAuthInherit.isAuthInherit(auth$1);
      var overrideAuth = isInherit && auth$1[auth.AuthValue.InHerit];
      var authData = this.getAuthDataToBuild(auth$1, securityScheme);
      if (!authData) return undefined;
      if (overrideAuth && ((_authData = authData) === null || _authData === void 0 ? void 0 : _authData.type) === overrideAuth.type) {
        authData = overrideAuth;
      }
      var _authData2 = authData,
        type = _authData2.type;
      var result = {
        type: type
      };
      var targetItem = authData[type || ''];
      if (type === auth.AuthValue.NoAuth) return result;
      if (!targetItem && type !== auth.AuthValue.NoAuth) return DEFAULT_AUTH_VALUE;
      return authData;
    }
  }, {
    key: "build",
    value: function build() {
      var auth$1 = this.resolveAuth();
      if (!auth$1) {
        return auth$1;
      }
      var type = auth$1.type;
      var result = {
        type: type
      };
      var targetItem = auth$1[type || ''];
      if (!type || type === auth.AuthValue.NoAuth) {
        return auth$1;
      }
      result[type] = Object.keys(targetItem).map(function (item) {
        return {
          key: item,
          value: targetItem[item]
        };
      });
      return result;
    }
  }, {
    key: "buildJSON",
    value: function buildJSON() {
      return this.build();
    }
  }]);
}();
exports.default = AuthBuilder;
exports.getAuthFromAuthAndSecuritySchemeUseCase = getAuthFromAuthAndSecuritySchemeUseCase;
exports.getInheritAuthInfo = getInheritAuthInfo;
exports.getUsedSecurityScheme = getUsedSecurityScheme;
exports.getUsedSecuritySchemes = getUsedSecuritySchemes;
exports.mergeSecurityScheme = mergeSecurityScheme;
exports.translateSecuritySchemeToAuth = translateSecuritySchemeToAuth;
